export default "__VITE_ASSET__ChUnUQvJ__"